import React, { Component, Fragment } from 'react';
import _ from 'lodash';

import { Icon } from 'office-ui-fabric-react/lib/Icon';
import { TooltipHost } from 'office-ui-fabric-react/lib/Tooltip';
import { getId } from 'office-ui-fabric-react/lib/Utilities';
import { Dropdown } from 'office-ui-fabric-react/lib/Dropdown';

export default class DropDownField extends Component {
  hostId = getId('tooltipHost');

  componentWillMount() {
    this.id = _.uniqueId('DropDownField');
  }

  render() {
    const { label, tooltip, required } = this.props;
    const forwardedProps = Object.assign({}, this.props);
    delete forwardedProps.label;
    return (
      <Fragment>
        <label
          className="ms-Label"
          required={required || false}
          htmlFor={this.id}
          style={{
            paddingTop: '5px',
            paddingBottom: '5px',
            display: 'inline-block',
          }}
        >
          {label}
        </label>
        {tooltip && (
          <div
            // there's a "padding-right: 12px" after the red asterix
            style={
              required
                ? { marginLeft: '-5px', display: 'inline-block' }
                : { marginLeft: '5px', display: 'inline-block' }
            }
          >
            {' '}
            <TooltipHost
              content={tooltip}
              id={this.hostId}
              calloutProps={{ gapSpace: 0 }}
            >
              <Icon iconName="Info" />
            </TooltipHost>
          </div>
        )}
        <Dropdown {...forwardedProps} />
      </Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/components/DropDownField/index.jsx